import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {MatTableDataSource} from "@angular/material/table";
import {FabTableState, filterStateChange, process} from "@fabric/components/table-filter/data-query";
import {Observable} from "rxjs";
import {MgoErrorProcessing} from "../../models/MgoErrorProcessing";
import {MgoErrorService} from "../../services/mgo-error.service";
import {MatPaginator} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {ErrorCodes} from "../../constants/ErrorCodes";
import {NotificationService} from "../../services/notification.service";
import {HttpErrorResponse} from "@angular/common/http";
import {SecurityService} from "../../services/security.service";
import {UserFunctionCode} from "../../constants/UserFunctionCode";
import {FabDateFilterOperator} from '../../shared-components/table-filter/date-filter/date-filter.component';
import {FabStringFilterOperator} from '../../shared-components/table-filter/string-filter/string-filter.component';

@Component({
  selector: 'app-mgo-error-processing',
  templateUrl: './mgo-error-processing.component.html',
  styleUrls: ['./mgo-error-processing.component.scss']
})
export class MgoErrorProcessingComponent implements OnInit {
  displayedColumns: string[] = ['nombreDeArchivo', 'nroShipper', 'transporteError', 'destinatarioError',
    'dunsError', 'dockError', 'fecProceso', 'reprocessButtons'];
  dataSource: MatTableDataSource<MgoErrorProcessing> = new MatTableDataSource<MgoErrorProcessing>();
  allData: MgoErrorProcessing[] = [];
  operators: FabStringFilterOperator[] = ['contains'];
  public dateOperators: FabDateFilterOperator[] = ['eq', 'gte', 'lte'];
  state: FabTableState = {
    skip: 0,
    take: 5,
    filter: [],
    sort: []
  };
  disableReprocessButton: boolean = false;
  disableMultipleReprocessButton: boolean = true;
  showReprocessButton: boolean = true;
  hideMultipleProcess: boolean = false;
  fileName: any[] = [];
  errors: HttpErrorResponse[] = [];
  selector: string;

  @ViewChild(MatPaginator) private paginator: MatPaginator;
  @ViewChild(MatSort) set matSort(sort: MatSort) { this.dataSource.sort = sort; }

  constructor(private mgoErrorService: MgoErrorService, private notificationService: NotificationService,
              private securityService: SecurityService,
              private elementRef: ElementRef) { }

  ngOnInit(): void {
    this.getAllData();
    this.selector = this.elementRef.nativeElement.tagName.toLowerCase();
  }

  getAllData() {
    this.fetchData().subscribe( {
      next: (response) => {
        this.allData = response;
        this.dataSource = new MatTableDataSource<MgoErrorProcessing>(response);
        if (response !== null) {
          this.setPagination();
        }
      }, complete: () => {
        this.showReprocessButton = this.securityService.can(UserFunctionCode.MGO_REPROCESS) && this.allData.length > 0;
        if (this.showReprocessButton) {
          // this.displayedColumns.unshift('checkbox');
        }
      }
    })
  }

  fetchData(): Observable<MgoErrorProcessing[]> {
    return this.mgoErrorService.getAll();
  }

  public filterChange(event: any) {
    this.state.skip = 0;
    // @ts-ignore
    this.state.filter = filterStateChange(event, this.state.filter);
    this.filterData();
  }

  private filterData() {
    this.dataSource.data = process(this.allData, this.state)
  }

  onChange(element: any) {
    if (element.isChecked) {
      this.fileName.push(element);
    } else {
      for (var i = 0; i < this.fileName.length; i++) {
        if (this.fileName[i].nombreDeArchivo === element.nombreDeArchivo) {
          this.fileName.splice(i, 1);
        }
      }
    }

    this.disableMultipleReprocessButton = this.fileName.length === 0
    this.disableReprocessButton = this.fileName.length > 0;
  }

  setPagination() {
    this.dataSource.paginator = this.paginator;
  }

  reprocessMgoFile(element: any) {
    this.mgoErrorService.reprocessMgoFile(element.id, element.nombreDeArchivo, element).subscribe({
      next: (response) => {
          if (response){
            this.getAllData();
            this.notificationService.open(ErrorCodes.MGO_REPROCESS_SUCCESS, 'success');
          } else {
            this.notificationService.open(ErrorCodes. MGO_REPROCESS_FAILED, 'error');
          }
        },
      error: (error) => {
        this.errors.push(error);
        this.notificationService.open(this.notificationService.getErrorByCode(error.errorCode),'error')
      }
    });
  }

}
